<template>
  <v-dialog v-model="internalValue" max-width="800px">
    <v-card>
      <v-card-title class="headline">Documentation</v-card-title>
      <v-card-text>
        <h2>Ce que mesure la page 📅</h2>
        <p>
          Les tableaux affichent le <strong>chiffre d'affaires « lifetime »</strong>
          (sur toute la durée de vie de l'article, et non uniquement sur la
          période sélectionnée) ainsi que les <strong>sessions</strong>
          associées, pour les articles <strong>créés pendant la période</strong>
          choisie dans le filtre de dates.
        </p>
        <p>
          Autrement dit, la période sert à sélectionner les articles
          <strong>selon leur date de création</strong> ; le chiffre d'affaires
          et les sessions pris en compte sont ensuite cumulés sur l'ensemble de
          la vie de ces articles.
        </p>

        <hr />

        <h2>Configuration des rédacteurs ✍️</h2>
        <p>
          Pour qu'un rédacteur apparaisse dans les tableaux, il doit d'abord
          être configuré dans l'onglet <strong>"Rédac Setup"</strong>.
          L'intégrité des données est essentielle, c'est pourquoi chaque
          rédacteur est identifié de manière unique par la paire
          <strong>adresse e-mail / site web</strong>.
        </p>
        <p>
          <strong>Attention :</strong> L'adresse e-mail à utiliser est celle qui
          est associée à l'alias de signature de l'article. Par exemple, si
          votre rédacteur signe ses articles avec l'alias "La Rédac", vous devez
          utiliser l'adresse e-mail liée à cet alias.
        </p>

        <hr />

        <h2>Code couleur pour les rédacteurs externes 🎨</h2>
        <p>
          Les tableaux des rédacteurs externes utilisent un code couleur pour
          vous aider à interpréter rapidement le ratio de rentabilité (chiffre
          d'affaires / coût) de chaque article.
        </p>
        <ul>
          <li>
            🔴 <strong>Rouge :</strong> Le ratio CA/coût est
            <strong>inférieur à 1</strong>. L'article génère moins de revenus
            que son coût.
          </li>
          <li>
            🔵 <strong>Bleu :</strong> Le ratio CA/coût est compris
            <strong>entre 0 et 1</strong>. L'article génère un revenu, mais
            celui-ci est encore inférieur à son coût.
          </li>
          <li>
            🟢 <strong>Vert :</strong> Le ratio CA/coût est
            <strong>supérieur à 1</strong>. L'article génère au moins deux fois
            plus de revenus que son coût, ce qui indique une bonne rentabilité.
          </li>
        </ul>

        <hr />

        <h2>Instructions pour les rédacteurs internes 📊</h2>
        <p>
          Pour les rédacteurs internes, vous devez d'abord télécharger le
          fichier Excel dédié. Une fois le fichier ouvert, il est crucial de
          renseigner les données dans la colonne <strong>"CA Annuel"</strong>.
          Ces informations sont nécessaires pour le calcul de la rentabilité des
          articles internes.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DocDialog",
  model: {
    prop: "value", // <-- Vue 2 utilise 'value' pour v-model par défaut
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); // émet l'événement pour mettre à jour le parent
      },
    },
  },
  methods: {
    closeDialog() {
      this.internalValue = false;
    },
  },
};
</script>
